import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
  Output,
  EventEmitter, inject,
} from '@angular/core';
import { IconFormat, Record } from 'src/app/models/record';
import { ResultsButtonConfiguration, ListResultsButtonConfiguration } from 'src/app/models/buttons-config';
import { Util } from 'src/app/util';
import { ApiService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { Rating } from 'src/app/models/rating';
import { ImageGalleryComponent } from '../image-gallery/image-gallery.component';
import { LocaleService } from 'src/app/services/locale.service';
import { BaseData } from '../card-item/models/base-data.model';
import { ViewMode } from 'src/app/state/user/searches/models/search';
import { ConfigService } from 'src/app/services/config.service';
import { ToastService } from '../../_core/services/toast.service';

@Component({
  selector: 'app-results-item',
  templateUrl: './results-item.component.html',
  styleUrls: ['./results-item.component.scss'],
})
export class ResultsItemComponent implements OnInit, OnChanges {
  private readonly toastService = inject(ToastService);

  @ViewChild(ImageGalleryComponent) gallery: ImageGalleryComponent;

  @Output()
  navigateResultsSection: EventEmitter<void> = new EventEmitter<void>();

  @Input()
  record: Record;

  @Input()
  rating: Rating;

  @Input()
  viewMode: ViewMode;

  issueDate: string;
  images: string[] = [];
  authService: AuthService;
  buttonsConfig;
  readOnly = true;

  IconFormat = IconFormat;

  baseData: BaseData;
  showPublicationDate: boolean;

  toggleShowGallery = () => {
    this.gallery.buildGallery();
  };

  constructor(
    authService: AuthService,
    private apiService: ApiService,
    private localeService: LocaleService,
    private configService: ConfigService,
  ) {
    this.authService = authService;
  }

  ngOnInit() {
    this.buildBaseData();
    this.showPublicationDate = this.configService.get().showPublicationDate;
    this.issueDate = Util.getLastIssueDate(this.record);
    this.readOnly = !this.authService.isAuthenticated();

    if (this.record.resourceTypes.includes('TIPO_IMAGEN')) {
      this.apiService.getRecordInfo(this.record.id, 'IMAGE').subscribe((images) => {
        this.images.push(...images.map((i) => i.path));
        if (this.authService.isAuthenticated() && this.gallery) {
          this.gallery.buildGallery();
        }
      });
    }

    this.buttonsConfig = !this.record.wishListInfo
      ? new ResultsButtonConfiguration()
      : new ListResultsButtonConfiguration();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.rating && changes.rating.isFirstChange) {
      this.rating = changes.rating.currentValue;
    }
  }

  copyListLinkToClipboard() {
    const slug = Util.slugify(this.record.title) + '-' + this.record.wishListInfo.id;
    const url = new URL(Util.getOrigin() + '/list/' + slug);
    Util.copyToClipboard(url.href);
    this.toastService.showToast('messages.copied', 'info');
  }

  private buildBaseData() {
    this.baseData = {
      record: this.record,
      author: this.record.author,
      title: this.record.title,
      cover: this.record.coverImageUrl,
      icon: this.record.icon,
      isList: Boolean(this.record?.wishListInfo),
    };
  }
}
